export const REMOVE_LINE = 'program/remove-line';
export const REMOVE_LINE_SUCCESS = 'program/remove-line-success';
export const REMOVE_LINE_FAIL = 'program/remove-line-fail';
